import { render, staticRenderFns } from "./ServiceTypePicker.vue?vue&type=template&id=5faf281f&scoped=true"
import script from "./ServiceTypePicker.vue?vue&type=script&lang=js"
export * from "./ServiceTypePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5faf281f",
  null
  
)

export default component.exports